import request from '../../../api';

/**
 * The checkout's two requests.
 *
 * There is no thunk for either: the old checkout form made them itself, from
 * inside a component. They are the same two calls, moved to where the layer
 * rule puts a request. Both throw; `useCheckout` decides what a failure says.
 */

/**
 * What a promotion code is worth — `{ discountUSD, discountType,
 * subscribePackageId }`. The server answers for any code it knows, whichever
 * package it is for; `promotionDiscount` in `pricing.js` works out what that
 * comes to on this one.
 */
export const getPromotion = (code) =>
    request
        .get(`/supscription/promotion/${encodeURIComponent(code)}/details`)
        .then((res) => res.data);

/**
 * Subscribes the signed-in reader to a package. Creates the subscription and
 * its `paymentId` whether or not anything is owed; the code, when there is one,
 * is applied by the server and not by what the page showed.
 */
export const subscribe = ({ packageId, promotionCode }) =>
    request
        .post('/student/subscribe', { subscriptionPackageId: packageId, promotionCode })
        .then((res) => res.data);
